import { render, staticRenderFns } from "./SQuesOne.vue?vue&type=template&id=52fed032&scoped=true&"
import script from "./SQuesOne.vue?vue&type=script&lang=js&"
export * from "./SQuesOne.vue?vue&type=script&lang=js&"
import style0 from "./SQuesOne.vue?vue&type=style&index=0&id=52fed032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fed032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
